import * as React from "react";
import { STATUS_META } from "../../theme/tokens";
import type { ThreadStatus } from "../../types/collaborateThread";

export type StatusPillProps = {
  status: ThreadStatus;
  size?: "sm" | "md";
  onClick?: () => void;
  disabled?: boolean;
};

/**
 * Tickets-page status chip: soft fill + semantic ink, no dot, no heavy border.
 */
const StatusPill: React.FC<StatusPillProps> = ({
  status,
  size = "sm",
  onClick,
  disabled,
}) => {
  const meta = STATUS_META[status];
  const label = `Status: ${meta.label}`;

  const style: React.CSSProperties = {
    fontSize: size === "sm" ? 11 : 12,
    fontWeight: 600,
    color: meta.fg,
    background: meta.bg,
    borderRadius: 20,
    padding: size === "sm" ? "2px 8px" : "3px 10px",
    display: "inline-flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    border: "none",
    lineHeight: 1.3,
  };

  if (onClick && !disabled) {
    return (
      <button
        type="button"
        className="collaborate-status-pill"
        style={{ ...style, cursor: "pointer", fontFamily: "inherit" }}
        onClick={onClick}
        aria-label={label}
      >
        {meta.label}
      </button>
    );
  }

  return (
    <span className="collaborate-status-pill" style={style} aria-label={label}>
      {meta.label}
    </span>
  );
};

export default StatusPill;
